import { IROVVideoCategory } from 'src/generated-types/rovvideo'
import { useDelete, usePost, usePut } from './reactQuery'

const baseUrl = (customerId: EntityId, localityId: EntityId) =>
  `customers/${customerId}/localities/${localityId}/rov-category`

export const rovCategoryEndpoints = {
  createROVCategory(customerId: EntityId, localityId: EntityId) {
    return `${baseUrl(customerId, localityId)}`
  },
  updateROVCategory(customerId: EntityId, localityId, id: EntityId) {
    return `${baseUrl(customerId, localityId)}/${id}`
  },
  deleteROVCategory(customerId: EntityId, localityId: EntityId) {
    return `${baseUrl(customerId, localityId)}`
  },
}

export const useCreateROVCategory = (customerId: EntityId, localityId: EntityId) =>
  usePost<IROVVideoCategory, { categoryName: string; isShared: boolean }>(
    rovCategoryEndpoints.createROVCategory(customerId, localityId),
  )

export const useUpdateROVCategory = (customerId: EntityId, localityId: EntityId, id: EntityId) =>
  usePut<IROVVideoCategory, any>(rovCategoryEndpoints.updateROVCategory(customerId, localityId, id))

export const useDeleteROVCategory = (customerId: EntityId, localityId: EntityId) =>
  useDelete<any>(rovCategoryEndpoints.deleteROVCategory(customerId, localityId))
